import { render, staticRenderFns } from "./FiscalYear.vue?vue&type=template&id=2b7a3ccd&scoped=true&"
import script from "./FiscalYear.vue?vue&type=script&lang=js&"
export * from "./FiscalYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7a3ccd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
